import { message } from 'antd';
/**
 *
 * @param {string} params
 */
export default function download(params) {
    // 拼接下载地址
    const url = `${window.location.origin}/operation/smart/common/downloadTemplate?fileName=${params}`
    // 使用原生JavaScript的fetch API发送GET请求
    fetch(url).then(response => {
      if (response.ok) {
        response.blob().then((blob) => {
          const a = document.createElement('a');
          const downUrl = window.URL.createObjectURL(blob);// 获取 blob 本地文件连接
          const filename = response.headers.get('Content-Disposition')?.split('filename=')[1]?.split('.') || []; // 获取请求头上的文件名称
          a.href = downUrl;
          a.download = params || `${decodeURI(filename[0])}.${filename[1]}`;
          a.click();
          window.URL.revokeObjectURL(downUrl);
        });
      }
    }).catch(() => {
      message.error('下载失败')
    });
  }
  